import { FC } from "react";
import { Ticket, TicketType } from "../../../components/TicketsPanel/Ticket"
import currencyIcon from '../../../icons/currency.png';
import { formatNumberWithSpaces } from "../../../utils/numbers";
import styles from './WheelWinnerPrize.module.scss';

export interface IWheelPrizeProps {
    type: TicketType | 'balance',
    value: number;
}

export const WheelWinnerPrize: FC<IWheelPrizeProps> = ({ type, value }) => {
    const getTicket = (type: TicketType) => {
        return (
            <div className={ styles.container }>
                <Ticket type={type} value={value} />
            </div>
        );
    }

    const getBalance = () => {
        return (
            <span className={ styles.container }>
                <img className={ styles.currency } src={ currencyIcon } alt="Currency Icon"  />
                <span className={ styles.balanceValue }>{ formatNumberWithSpaces(value) }</span>
            </span>
        );
    }
    
    return type === 'balance' ? getBalance() : getTicket(type);
}